import ApiService from "@/common/ApiService";
import urlConfig from "@/../public/urlConfig.json";
import vue from "vue";

var apiUrl = '';
var apiService = null;
fetch(process.env.BASE_URL + "urlConfig.json")
  .then((response) => response.json())
  .then((config) => {

    apiUrl = config.tourBaseAddress;
     apiService = new ApiService(apiUrl);
  })
  

import { SET_ERROR, SET_CITIES } from "./types";
require("linqjs");

export default {
  state: () => ({
    cities: [],
    locations: [],
   
  }),
  mutations: {
    SetLocations(state, locations) {
      state.locations = locations;
    },
  },
  getters: {
    GetLocations(state) {
      return state.locations;
    },
  },
  actions: {
    async getLocations(context) {

      try {
        const url = "/Location/GetLocations";
        const items = (await apiService.Get(url)).data;
        context.commit('SetLocations', items.data);
        return items.data;

      } catch (err) {

        throw err;
      } finally {
      }
    },

    async getHotelList(context, params) {
      try {
          const response = (await apiService.Get("BaseInfo/GetHotelList"));

          return (response.data.data);
      } catch (err) {
          console.log(err);
      }
  },

  },
};
